"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GraphikBoldWeb = _interopRequireDefault(require("../fonts/graphik/Graphik-Bold-Web.woff"));
var _GraphikMediumWeb = _interopRequireDefault(require("../fonts/graphik/Graphik-Medium-Web.woff"));
var _GraphikMediumItalicWeb = _interopRequireDefault(require("../fonts/graphik/Graphik-MediumItalic-Web.woff"));
var _GraphikRegularWeb = _interopRequireDefault(require("../fonts/graphik/Graphik-Regular-Web.woff"));
var _GraphikSemiboldWeb = _interopRequireDefault(require("../fonts/graphik/Graphik-Semibold-Web.woff"));
var _GTEestiBoldWeb = _interopRequireDefault(require("../fonts/haglofs/GT-Eesti-Bold-Web.woff"));
var _GTEestiBoldItalicWeb = _interopRequireDefault(require("../fonts/haglofs/GT-Eesti-BoldItalic-Web.woff"));
var _GTEestiRegularWeb = _interopRequireDefault(require("../fonts/haglofs/GT-Eesti-Regular-Web.woff"));
var _GTEestiRegularItalicWeb = _interopRequireDefault(require("../fonts/haglofs/GT-Eesti-RegularItalic-Web.woff"));
var _default = exports.default = [
// Graphik
{
  '@font-face': {
    fontFamily: 'Graphik',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `url(${_GraphikRegularWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'Graphik',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 500,
    src: `url(${_GraphikMediumWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'Graphik',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'italic',
    fontWeight: 500,
    src: `url(${_GraphikMediumItalicWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'Graphik',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 600,
    src: `url(${_GraphikSemiboldWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'Graphik',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 700,
    src: `url(${_GraphikBoldWeb.default}) format("woff")`
  }
},
// GT-Eesti
{
  '@font-face': {
    fontFamily: 'GT-Eesti',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `url(${_GTEestiRegularWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'GT-Eesti',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'italic',
    fontWeight: 400,
    src: `url(${_GTEestiRegularItalicWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'GT-Eesti',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 700,
    src: `url(${_GTEestiBoldWeb.default}) format("woff")`
  }
}, {
  '@font-face': {
    fontFamily: 'GT-Eesti',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontStyle: 'italic',
    fontWeight: 700,
    src: `url(${_GTEestiBoldItalicWeb.default}) format("woff")`
  }
}, {
  '*': {
    fontFamily: 'Graphik, arial, sans-serif'
  }
}, {
  html: {
    height: '100%'
  }
}, {
  body: {
    height: '100%',
    margin: '0'
  }
}, {
  '#root': {
    height: '100%'
  }
}];